<div class="container">
  <div class="card">
    <div class="card-body">
      <div class="sunleon-container-parametre">
        <div class="container">
          <div class="table-responsive w-100">
            <table *ngIf="parametres$ | async as parametres" class="table table-bordered table-striped">
              <thead class="thead-dark sticky-top">
                <tr>
                  <th scope="col">Code</th>
                  <th scope="col">Valeur</th>
                  <th scope="col">Unité</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let parametreDto of parametres; let i = index"
                  [ngClass]="{ 'selected-row': i === selectedRowIndex }"
                  (click)="handleRowClick(i)"
                >
                  <td [attr.data-toggle]="'tooltip'" [attr.title]="parametreDto.desc">
                    {{ parametreDto.code }}
                  </td>
                  <td>
                    <ng-container *ngIf="parametreDto.type.toLowerCase() === 'simple'">
                      {{ parametreDto.valeur }}
                    </ng-container>
                    <ng-container *ngIf="isM0IParameter(parametreDto)">
                      <div class="m0i-table-wrapper">
                        <table class="table table-sm table-bordered m0i-table mb-0">
                          <thead>
                            <tr>
                              <th>Année</th>
                              <th>Valeur</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of getM0IRows(parametreDto.valeur)">
                              <td>{{ row.annee }}</td>
                              <td>{{ row.valeur }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ng-container>
                  </td>
                  <td>
                    {{ parametreDto.unite }}
                  </td>
                  <td>
                    <i
                      *ngIf="parametreDto.type.toLowerCase() === 'simple'"
                      role="button"
                      class="bi bi-pencil-square"
                      [class.icon-color-change]="!iconClicked"
                      (click)="openEditionModal(parametreDto)"
                    >
                    </i>
                    <i
                      *ngIf="parametreDto.type.toLowerCase() === 'tableau'"
                      role="button"
                      class="bi bi-pencil-square"
                      [class.icon-color-change]="!iconClicked"
                      (click)="openTableauEditionModal(parametreDto)"
                    >
                    </i>
                    <i
                      *ngIf="parametreDto.type.toLowerCase() === 'spécifique'"
                      role="button"
                      class="bi bi-pencil-square"
                      [class.icon-color-change]="!iconClicked"
                      (click)="openBddEnedisEditionModal(parametreDto)"
                    >
                    </i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
